import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { ModalPainel } from "@/components/ModalPainel";
import { Form } from "./form";
import { api } from "@/services/api";
import { useState, useEffect } from "react";
import ModalRetorno from "@/modules/Portaria/components/ModalRetorno";

export function EditPermissoes() {
  const { id, idpermissao } = useParams();
  const [isActive, setIsActive] = useState<any>();
  const [rotina, setRotina] = useState<any>();
  const [descricao, setDescricao] = useState<any>();
  const [mensagemErro, setMensagemErro] = useState<string | null>(null);
  const [mensagemSucesso, setMensagemSucesso] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPermissao(idpermissao);
  }, [idpermissao]);


  async function fetchPermissao(idpermissao: any) {
    try {
      const response = await api.get(`permissao/${idpermissao}`);
      const rotinaId = response.data.rotina?.id;
      const ativo = response.data.ativo;
      setDescricao(response.data.rotina.nome)
      setRotina(rotinaId)
      setIsActive(ativo)
    } catch (error) {
      return null;
    }
  }
  async function handleSave() {
    try {
      const payload = {
        ativo: isActive ?? false, 
        funcionalidade: null,
        rotina: rotina,
        usuario: id,
      };

      await api.put(`permissao/${idpermissao}`, payload);

      setMensagemSucesso('Permissão atualizada com sucesso');
    } catch (error) {
      setMensagemErro('Erro ao atualizar as Permissão.');
      alert("Não foi possível salvar a permissão. Tente novamente.");
    }
  }

  function handleIsActiveChange(active: boolean) {
    setIsActive(active);
  }

  return (
    <>
        {(mensagemErro || mensagemSucesso) && (
        <ModalRetorno
          isOpen={true}
          onClose={() => {
            setMensagemErro(null);
            setMensagemSucesso(null);
            navigate(-1)
          }}
          mensagem={mensagemErro || mensagemSucesso || ''}
          tipo={mensagemErro ? 'erro' : 'sucesso'}
        />
      )}
      <ModalPainel>
        <Box p={5}>
          <Form
            title={`${descricao}`}
            handleSave={handleSave}
            value={isActive}
            IsActive={handleIsActiveChange} 
          />
        </Box>
      </ModalPainel>
    </>
  );
}
